<template>
  <div
    class="flex gap-6 md:gap-10 md:max-w-6xl justify-between w-full items-end"
  >
    <h2 class="font-bold text-18" v-html="title"></h2>
    <div class="hidden md:flex gap-6">
      <button
        value="prev"
        aria-label="Previous"
        class="testimonial-swiper-prev h-8 w-8 bg-grayscale-13 hover:bg-grayscale-30 rounded-full flex justify-center items-center"
      >
        <i class="icon-left text-24" />
      </button>
      <button
        value="next"
        aria-label="Next"
        class="testimonial-swiper-next h-8 w-8 bg-grayscale-13 hover:bg-grayscale-30 rounded-full flex justify-center items-center"
      >
        <i class="icon-right text-24" />
      </button>
    </div>
  </div>
  <div class="mt-6 md:mt-10 relative">
    <ClientOnly>
      <swiper
        loop
        passiveListeners
        :slidesPerView="'auto'"
        :spaceBetween="8"
        :freeMode="false"
        :mousewheel="true"
        :keyboard="true"
        :navigation="{
          nextEl: '.testimonial-swiper-next',
          prevEl: '.testimonial-swiper-prev',
        }"
        :modules="[FreeMode, Navigation, Mousewheel, Keyboard]"
        class="carousel-padding"
        :breakpoints="{
          300: {
            allowTouchMove: true,
            slidesPerGroupAuto: false,
          },
          1024: {
            allowTouchMove: true,
            slidesPerGroupAuto: true,
          },
        }"
      >
        <swiper-slide
          v-for="testimonial in testimonials"
          :key="testimonial._id"
          class="w-auto"
        >
          <div
            class="p-6 flex flex-col gap-6 md:w-[693px] bg-grayscale-10 border border-grayscale-20 rounded-8"
          >
            <div class="flex flex-col gap-4">
              <div class="flex-flex-col gap-2">
                <div class="flex justify-between">
                  <h3 class="text-14 font-semibold">
                    {{ testimonial.name }}
                  </h3>
                  <div class="text-10 flex gap-2 cursor-default">
                    <p v-for="i of testimonial.stars">⭐</p>
                  </div>
                </div>
                <div class="text-12 text-grayscale-80 flex gap-4">
                  <p class="">{{ testimonial.productType }}</p>
                  <p class="">●</p>
                  <p class="">{{ testimonial.date }}</p>
                </div>
              </div>
              <p class="text-14 text-grayscale-80">
                {{ testimonial.message }}
              </p>
            </div>
            <div class="flex gap-2">
              <general-button
                v-for="link in testimonial.links"
                :key="link.label"
                additional-classes=""
                :redirect="link.link"
                height="small"
                color="trans"
              >
                {{ link.label }}
              </general-button>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { FreeMode, Navigation, Mousewheel, Keyboard } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import type { Testimonial } from "@/types/testimonial";
import GeneralButton from "@/components/layout/buttons/GeneralButton.vue";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/mousewheel";
import "swiper/css/keyboard";

const props = defineProps({
  testimonials: {
    type: Array as PropType<Testimonial[]>,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});

const testimonials = props.testimonials.sort((a, b) =>
  a.message > b.message ? -1 : 1,
);
</script>

<style scoped>
/* .carousel-padding {
  padding-left: 24px;
  padding-right: 24px;
} */

.swiper-slide {
  width: 80vw;
}
</style>
